/**
 * The one-time control hint (§6, §22): the only framing text the game ever
 * shows. Remembered per device so it never shows twice.
 */

const KEY = 'crime-rpg:hint-seen';

export const HINT = 'Tap a place to walk there. Tap a person to see what you make of them.';

export function hintSeen(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function markHintSeen(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // Private mode or blocked storage: the hint shows again next time. Fine.
  }
}
